// Setup global namespace
var FRAMEWORK = window.FRAMEWORK || {};
FRAMEWORK.extend = FRAMEWORK.extend || {};

// Configure RequireJS
FRAMEWORK.requireConfig = {
	context : 'framework',
	baseUrl : '/js',
	baseBlocksUrl : 'blocks',
	waitSeconds : 15,
	paths : {
		jquery : 'vendor/jquery/jquery',
		'jquery.validate' : 'vendor/jquery/jquery.validate',
		'jquery.validate.wrapper' : 'wrappers/jquery.validate.wrapper',
		'jquery.validate.unobtrusive' : 'vendor/jquery/jquery.validate.unobtrusive',
		'jquery.validate.unobtrusive.wrapper' : 'wrappers/jquery.validate.unobtrusive.wrapper',
		'jquery.validate.unobtrusive-ajax' : 'vendor/jquery/jquery.validate.unobtrusive-ajax',
		b : 'block',
	},
	// Contains the attributes that a module or modules in a path should have which is used in onNodeCreated
	moduleAttributes : {
		'blocks/' : { crossorigin : 'anonymous' },
		'stand-alone/' : { crossorigin : 'anonymous' },
		'utilities/' : { crossorigin : 'anonymous' },
		'validation/' : { crossorigin : 'anonymous' },
		'vendor/' : { crossorigin : 'anonymous' },
		'wrappers/' : { crossorigin : 'anonymous' },
		main : { crossorigin : 'anonymous' },
		b : { crossorigin : 'anonymous' },
		locale : { crossorigin : 'anonymous' },
		utility : { crossorigin : 'anonymous' },
		jquery : { crossorigin : 'anonymous' },
	},
	// Callback after a node is created using require
	onNodeCreated : function( node, config, module ) {
		'use strict';

		// Set the keys of moduleAttributes into an array
		var moduleAttributesKeys = Object.keys( config.moduleAttributes ),
			moduleAttributesKey,
			moduleAttributes,
			// Get the index of the module in the moduleAttributesKeys array
			indexCheck = moduleAttributesKeys.indexOf( module ),
			// If module is found then set the start index to it else start at 0 for the loop
			i = ( indexCheck === -1 ) ? 0 : indexCheck,
			n,
			// Bools used for checking if module is in directory e.g vendor/
			startsBool,
			endsBool;

		// Remove default crossorigin

		// Loop through the keys
		for ( i; i < moduleAttributesKeys.length; i += 1 ) {
			// Checks if module name starts with with the key name
			startsBool = module.indexOf( moduleAttributesKeys[ i ] ) === 0;
			// Checks to see if key name ends with '/' to ensure it's a directory
			endsBool = moduleAttributesKeys[ i ].lastIndexOf( '/' ) === ( moduleAttributesKeys[ i ].length - '/'.length );

			// If the key matches the module enter if statement or if module starts with the key and the key ends with a '/' then enter if statement (for module in directory)
			if ( ( module === moduleAttributesKeys[ i ] ) || ( startsBool && endsBool ) ) {
				moduleAttributesKey = moduleAttributesKeys[ i ];
				// Make array with the attribute keys of the module
				moduleAttributes = Object.keys( config.moduleAttributes[ moduleAttributesKey ] );
				// Loop through the attributes and set the attribute with the value
				for ( n = 0; n < moduleAttributes.length; n += 1 ) {
					node.setAttribute( moduleAttributes[ n ], config.moduleAttributes[ moduleAttributesKey ][ moduleAttributes[ n ] ] );
				}
				// Break out of for loop as all attributes have already been set
				break;
			}
		}
	},
	packages : [
		{
			name : 'dayjs',
			location : 'vendor/day',
			main : 'dayjs',
		},
		{
			name : 'highcharts',
			location : 'vendor/highcharts11',
			main : 'highcharts',
		},
		{
			name : 'htmx',
			location : 'vendor/htmx',
			main : 'htmx',
		},
	],
	shim : {
		'vendor/pikaday' : [ 'dayjs' ],
		'jquery.validate.unobtrusive-ajax' : [ 'jquery', 'jquery.validate', 'jquery.validate.unobtrusive' ],
		'vendor/htmx/ext/sse' : [ 'htmx' ],
		'vendor/htmx/ext/preload' : [ 'htmx' ],
	},
	map : {
		'*' : {
			jquery : 'jquery',
			'jquery.validate' : 'jquery.validate.wrapper',
			'jquery.validate.unobtrusive' : 'jquery.validate.unobtrusive.wrapper',
		},
		'jquery.validate.wrapper' : { 'jquery.validate' : 'jquery.validate' },
		'jquery.validate.unobtrusive.wrapper' : { 'jquery.validate.unobtrusive' : 'jquery.validate.unobtrusive' },
		'jquery.validate.unobtrusive' : { 'jquery-validation' : 'jquery.validate.wrapper' },
	},
	callback : function() {
		'use strict';

		var event;
		if ( typeof Event === 'function' ) {
			event = new Event( 'requireready' );
		} else {
			event = document.createEvent( 'Event' );
			event.initEvent( 'requireready', true, true );
		}
		document.dispatchEvent( event );
	},
};

// Set localisation setting
FRAMEWORK.locale = {
	default : {
		aContextHelp : {
			formText : 'Help',
			closeText : 'Close',
		},
		aDate : {
			locale : 'en-gb',
			format : 'DD/MM/YYYY',
			previousMonth : 'Previous month',
			nextMonth : 'Next month',
			months : [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
			weekdays : [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
			weekdaysShort : [ 'S', 'M', 'T', 'W', 'T', 'F', 'S' ],
			interactionInstruction : 'Use the arrow keys to pick a date',
			clearLabel : 'Clear',
			yearLabel : 'Year',
			monthLabel : 'Month',
			triggerLabelSingle : 'Select date',
			totalSelectedSingular : '<strong>{days} day</strong> selected',
			totalSelectedPlural : '<strong>{days} days</strong> selected',
			startDateTitle : 'Select start date',
			startDateEditTitle : 'Edit start date',
			endDateTitle : 'Select end date',
			endDateEditTitle : 'Edit end date',
		},
		aFileUpload : { multipleCaption : '{count} files selected' },
		aFootnote : { backToContent : 'Back to content' },
		aPlusMinus : {
			plus : 'plus',
			minus : 'minus',
		},
		aTextarea : {
			multipleCaption : '{count} characters left',
			limitMessage : 'There is a character limit of {count}',
			limitMetMessage : 'Character limit of {count} met',
		},
		mChapterIndex : {
			previousText : 'Previous',
			nextText : 'Next',
		},
		mCardNotification : { closeText : 'Close' },
		mCheckboxGroupMultiselect : {
			pleaseSelect : 'Please select\u2026',
			allSelected : 'All selected',
			selected : ' selected',
			selectAll : 'Select all',
		},
		mCookiePolicy : {
			successfullySaved : 'The cookie setting has been successfully saved.',
			failed : 'Cookies are not enabled so your preference could not be saved.',
		},
		mCreditCard : {
			default : 'For %s, look for the three digits on the back',
			noMatch : 'Look for the three digits on the back',
			amex : 'For American Express, look for the four digits on the front',
		},
		mFormRowHelp : {
			showMore : 'Show more',
			showLess : 'Show less',
		},
		mNotificationBadge : {
			closeText : 'Close',
			failed : 'Cookies are not enabled so your preference could not be saved.',
		},
		mMediaPlayer : {
			progress : 'played',
			progressTime : 'time',
			restart : 'Restart',
			rewind : 'Rewind',
			play : 'Play',
			playVideo : 'Play video',
			playAudio : 'Play audio',
			pause : 'Pause',
			forward : 'Forward',
			mute : 'Mute',
			volume : 'Volume',
			captions : 'Captions',
			subtitles : 'Subtitles',
			fullscreen : 'Fullscreen',
			seconds : 'seconds',
			on : 'on',
			off : 'off',
		},
		mPredictiveSearch : {
			instruction : 'When auto-complete results are available use up and down arrows to review and enter to select.  Touch device users, explore by touch or with swipe gestures.',
			resultsFound : 'results are available.',
			noResults : 'No search results.',
		},
		mShowHide : {
			expand : 'Show',
			contract : 'Hide',
			about : ' detail about ',
		},
		mShowMore : {
			expand : 'Show more',
			contract : 'Show less',
			about : ' about ',
			description : 'this topic',
		},
		mStickyCtaBar : { mobileText : 'Ready to get going?' },
		mTabs : {
			previousText : 'Previous',
			nextText : 'Next',
			loadingText : 'Please wait',
		},
		oAccessibilitySettings : {
			// eslint-disable-next-line max-len
			error : 'The ability to store your accessibility preferences for this website requires the use of cookies. Please enable cookies for this site so that we can save your preference, or use the prefer reduced motion setting on your device.',
			reduced : 'Animations and transitions have been automatically disabled for this website in accordance with your device settings.',
			success : 'Your preferences have been updated successfully.',
		},
		oCardSelect : {
			maxMessage : 'Maximum reached - Please deselect an option to proceed',
		},
		oCarousel : {
			carouselLabel : 'Carousel',
			previousPageLong : 'Previous, {x} of {y}',
			previousPage : 'Previous',
			page : '{x} of {y}',
			nextPageLong : 'Next, {x} of {y}',
			nextPage : 'Next',
			slide : 'slide',
		},
		oFaqPanel : { showMore : 'Show more' },
		oMasthead : {
			menuText : 'Menu',
			closeMenu : 'Close menu',
			closeText : 'Close',
			loadingText : 'Please wait',
			switcherInitial : 'Select your preferred option',
			switcherSelection : 'You are on {option}',
			primaryNavigationLabel : 'Primary navigation',
		},
		oModal : {
			closeText : 'Close',
			loadingText : 'Please wait',
			contentLabel : 'Modal content',
		},
		oWallet : {
			nextButton : 'Next',
			previousButton : 'Back',
		},
	},
};

FRAMEWORK.timings = {
	default : {
		t100ms : 100,
		t150ms : 150,
		t200ms : 200,
		t250ms : 250,
		t300ms : 300,
		t350ms : 350,
		t500ms : 500,
		t1s : 1000,
	},
};

FRAMEWORK.componentSettings = {
	mDoughnutChart : {
		color : 'accent-dark-1', // Accent dark 1 default (Aviva Blue)
		multiSegmentColors : [ '#1a61bd', '#a9b2c6', '#5a8ccc', '#c2c8d5', '#7988a9' ], // Default colours for multisegment
		accentSegmentColors : {
			// Standard accent colours
			'accent-dark-1' : '#004fb6', // Aviva Blue
			'accent-dark-2' : '#004fb6', // Aviva Blue
			'accent-dark-3' : '#002f14', // Bottle Green
			'accent-dark-4' : '#5c596d', // Warm Grey
			'accent-dark-5' : '#4e1758', // Plum
			'accent-dark-6' : '#4e1758', // Plum
			'accent-dark-7' : '#005a6c', // Dark Teal
			'accent-dark-8' : '#444', // Dark Grey
			// Aviva specific accent colours
			'accent-light-3' : '#eee',
			'accent-light-5' : '#ffd900',
			'aviva-blue' : '#004fb6',
			'defining-grey' : '#ccc',
			segment1 : '#1a61bd',
			segment2 : '#a9b2c6',
			segment3 : '#5a8ccc',
			segment4 : '#c2c8d5',
			segment5 : '#7988a9',
		},
		basecolor : 'defining-grey', // Defining grey
	},
};

FRAMEWORK.animation = true; // Setup global animation variable

// Footer intersection observer for animation
const footer = document.querySelector( '.m-footer' );
if ( footer ) {
	footer.classList.remove( 'footer-animate' );
	// eslint-disable-next-line strict
	const observer = new IntersectionObserver( entries => {
		entries.forEach( entry => {
			if ( entry.isIntersecting ) {
				footer.classList.add( 'footer-animate' );
				return;
			}

			footer.classList.remove( 'footer-animate' );
		});
	});

	observer.observe( document.querySelector( '.m-footer-content > .l-content-container' ) );
}


FRAMEWORK.standalone = false;

FRAMEWORK.functions = {

	setupInitital : function() {
		'use strict';

		FRAMEWORK.requireBasicConfig = {
			context : 'framework',
			baseUrl : FRAMEWORK.requireConfig.baseUrl,
			moduleAttributes : {},
			waitSeconds : 15,
		};

		if ( FRAMEWORK.requireInitConfig && typeof FRAMEWORK.requireInitConfig === 'object' ) {
			if ( FRAMEWORK.requireInitConfig.baseUrl !== null ) {
				FRAMEWORK.requireBasicConfig.baseUrl = FRAMEWORK.requireInitConfig.baseUrl;
				FRAMEWORK.requireConfig.baseUrl = FRAMEWORK.requireInitConfig.baseUrl;
			}

			if ( FRAMEWORK.requireInitConfig.appUrl !== null ) {
				FRAMEWORK.requireConfig.paths.app = FRAMEWORK.requireInitConfig.appUrl;
			}

			Object.keys( FRAMEWORK.requireInitConfig.moduleAttributes ).forEach( function loop( key ) {
				FRAMEWORK.requireBasicConfig.moduleAttributes[ key ] = FRAMEWORK.requireInitConfig.moduleAttributes[ key ];
				FRAMEWORK.requireConfig.moduleAttributes[ key ] = FRAMEWORK.requireInitConfig.moduleAttributes[ key ];
			});
		}
	},

	// Extend require config
	extendRequire : function() {
		'use strict';

		var require,
			requireExtend,
			objs,
			arrs,
			blocked,
			origCallback,
			deepMerge;

		// Object.assign polyfill
		if ( typeof Object.assign !== 'function' ) {
			// Must be writable: true, enumerable: false, configurable: true
			Object.defineProperty( Object, 'assign', {
				value : function assign( target, varArgs ) { // eslint-disable-line no-unused-vars
					var to,
						index,
						nextSource;

					// .length of function is 2
					if ( target === null ) { // TypeError if undefined or null
						throw new TypeError( 'Cannot convert undefined or null to object' );
					}

					to = Object( target );

					for ( index = 1; index < arguments.length; index++ ) {
						nextSource = arguments[ index ];

						if ( nextSource !== null ) { // Skip over if undefined or null
							Object.keys( nextSource ).forEach( function loop( nextKey ) { // eslint-disable-line no-loop-func
								// Avoid bugs when hasOwnProperty is shadowed
								if ( Object.prototype.hasOwnProperty.call( nextSource, nextKey ) ) {
									to[ nextKey ] = nextSource[ nextKey ];
								}
							});
						}
					}
					return to;
				},
				writable : true,
				configurable : true,
			});
		}

		require = FRAMEWORK.requireConfig;
		requireExtend = FRAMEWORK.extend.requireConfig;
		objs = [ 'paths', 'bundles', 'shim', 'map', 'config', 'moduleAttributes' ];
		arrs = [ 'packages', 'deps' ];
		blocked = [ 'baseUrl', 'skipDataMain', 'baseBlocksUrl' ];

		deepMerge = function( target, source ) {
			var result = target;

			if ( !source ) {
				return target; // Null, undefined values check
			}

			if ( Object.prototype.toString.call( source ) === '[object Array]' ) {
				if ( Object.prototype.toString.call( result ) !== '[object Array]' ) {
					result = [];
				}
				source.forEach( function loop( child, index ) {
					if ( result[ index ] ) {
						result[ index ] = deepMerge( result[ index ], source[ index ] );
					} else {
						result[ index ] = source[ index ];
					}
				});
			} else if ( typeof source === 'object' ) {
				// It is an object literal
				if ( typeof result !== 'object' ) {
					result = {};
				}
				Object.keys( source ).forEach( function loop( key ) {
					if ( result[ key ] ) {
						result[ key ] = deepMerge( result[ key ], source[ key ] );
					} else {
						result[ key ] = source[ key ];
					}
				});
			} else if ( result ) {
				// Do nothing
			} else {
				result = source; // Dont overwrite any original values
			}

			return result;
		};

		if ( requireExtend && typeof requireExtend === 'object' ) {
			Object.keys( requireExtend ).forEach( function loop( prop ) {
				var x,
					y;
				if ( blocked.indexOf( prop ) > -1 ) {
					throw new Error( 'You are not permitted to override `' + prop + '` in your config' );
				}

				if ( objs.indexOf( prop ) > -1 ) {
					require[ prop ] = deepMerge( require[ prop ], requireExtend[ prop ] );
					return;
				}

				if ( arrs.indexOf( prop ) > -1 ) {
					x = require[ prop ] || [];
					y = requireExtend[ prop ] || [];
					require[ prop ] = [].concat( x, y );
					return;
				}

				if ( prop === 'callback' && requireExtend.callback === 'function' ) {
					// Callback already exists on config, wrap and call both
					if ( require.callback ) {
						origCallback = require.callback;
						require.callback = function callback() {
							origCallback.apply( this, arguments );
							requireExtend.callback.apply( this, arguments );
						};
					} else {
						require.callback = requireExtend.callback;
					}
					return;
				}

				require[ prop ] = requireExtend[ prop ];
			});
		}
	},

	// Function to merge locale settings with defaults
	setLocalisation : function( utility ) {
		'use strict';

		var lang = document.documentElement.lang;

		if ( typeof FRAMEWORK.extend.locale !== 'undefined' && FRAMEWORK.extend.locale[ lang ] ) {
			FRAMEWORK.locale.settings = utility.extend({}, FRAMEWORK.locale.default, FRAMEWORK.extend.locale[ lang ] );
		} else {
			FRAMEWORK.locale.settings = utility.extend({}, FRAMEWORK.locale.default, null );
		}
	},

	// Function to merge component settings with defaults
	setComponentSettings : function( utility ) {
		'use strict';

		if ( FRAMEWORK.extend.componentSettings && typeof FRAMEWORK.extend.componentSettings === 'object' ) {
			FRAMEWORK.componentSettings = utility.extend( FRAMEWORK.componentSettings, FRAMEWORK.extend.componentSettings );
		} else {
			// Do nothing
		}
	},

	// Setup global variable for animation setting and set global class for css animation
	setAnimation : function( utility, cookie ) {
		'use strict';

		if ( FRAMEWORK.extend.timings && typeof FRAMEWORK.extend.timings === 'object' ) {
			// Do nothing
		} else {
			FRAMEWORK.extend.timings = {};
		}

		// Loop through any additional timing values and add them to the default list
		Object.keys( FRAMEWORK.extend.timings ).forEach( function loop( key ) {
			if ( Object.prototype.hasOwnProperty.call( FRAMEWORK.timings.default, key ) ) {
				// Do not overwrite default time values
			} else {
				// Add new timing value
				FRAMEWORK.timings.default[ key ] = FRAMEWORK.extend.timings[ key ];
			}
		});

		// Setup current timings to match default
		FRAMEWORK.timings.current = utility.extend({}, FRAMEWORK.timings.default );

		if ( cookie.cookie.get( 'animation_disable_decision' ) === 'true' || FRAMEWORK.animationOff || FRAMEWORK.testEnv || window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
			FRAMEWORK.animation = false; // Setup global animation variable
			window.document.documentElement.className = window.document.documentElement.className.replace( 'u-animation', '' ); // Remove class if there

			Object.keys( FRAMEWORK.timings.current ).forEach( function loop( key ) {
				if ( Object.prototype.hasOwnProperty.call( FRAMEWORK.timings.current, key ) ) {
					FRAMEWORK.timings.current[ key ] = 0;
				}
			});

			if ( typeof jQuery === 'function' ) {
				jQuery.fx.off = true;
			}
		} else {
			FRAMEWORK.animation = true; // Setup global animation variable
			window.document.documentElement.className += ' u-animation'; // Turn on animation for CSS
		}
	},

	// Function to scan all modules for a data attribute to link to required JS and run
	moduleScan : function() {
		'use strict';

		// Get all elements with data-module attribute but not got an intersection observer or not had their modules loaded already
		var elements = document.querySelectorAll( '[data-module]:not(.has-module-observer):not(.has-modules-loaded)' ),
			instantLoadModulesRegex = new RegExp( '(m-tabs)|(m-showhide)+', 'g' );
		Array.prototype.forEach.call( elements, function loop( elm ) {
			var instantLoad = elm.getAttribute( 'data-module-load' ),
				modules = elm.getAttribute( 'data-module' ),
				instantLoadModules = instantLoadModulesRegex.test( modules ),
				rootMargin = '256px',
				moduleIntersectionObserver,
				eventListenerFn = function() {
					FRAMEWORK.functions.loadModules( elm );
					elm.classList.remove( 'has-module-observer' );
					moduleIntersectionObserver.unobserve( elm );
					elm.removeEventListener( 'loadModule', eventListenerFn );
				};

			// If intersection observers are supported and the module shouldn't be loaded instantly then add an intersection observer
			if ( 'IntersectionObserver' in window && ( instantLoad !== 'true' && instantLoadModules === false && !FRAMEWORK.testEnv ) ) {
				moduleIntersectionObserver = new IntersectionObserver( function listener( entries ) {
					entries.forEach( function innerLoop( entry ) {
						if ( entry.isIntersecting ) {
							eventListenerFn();
						}
					});
				}, { rootMargin : rootMargin });

				elm.classList.add( 'has-module-observer' );
				moduleIntersectionObserver.observe( elm );
				elm.addEventListener( 'loadModule', eventListenerFn );
			} else {
				FRAMEWORK.functions.loadModules( elm );
			}
		});
	},

	// Function to take the date-module attribute and load all the modules listed within it
	loadModules : function( elm ) {
		'use strict';
		var modules = elm.getAttribute( 'data-module' );

		if ( modules && !elm.classList.contains( 'has-modules-loaded' ) ) {
			modules = modules.split( ', ' );

			if ( typeof modules === 'string' ) {
				modules = [ modules ];
			}

			Array.prototype.forEach.call( modules, function innerLoop( module ) {
				if ( module !== '' ) {
					FRAMEWORK.require( [ 'b!' + module ], function innerFn( mod ) {
						if ( mod && Object.prototype.hasOwnProperty.call( mod, 'initInstance' ) ) {
							mod.initInstance( elm );
							// Add a class to say modules have been loaded to try and prevent over processing of elements
							elm.classList.add( 'has-modules-loaded' );
						}
					});
				}
			});
		}
	},

	/*
	 *  Load any block modules that are on the page, and run their
	 *  initInstances function if one exists. We also pass in the
	 *  element that the module was referenced on as their may be
	 *  more than one copy of the block on the page.
	 */
	setupPage : function() {
		'use strict';

		// Set base URL based on where init.js is being loaded from
		var requiredPolyfills = [],
			requiredScripts = [ 'utility', 'vendor/cookie' ];

		if ( window.CSS && window.CSS.supports && window.CSS.supports( 'object-fit', 'cover' ) ) {
			// Not IE11 or below so do nothing
		} else {
			// Load the polyfills for IE11 and below
			requiredPolyfills.push( 'vendor/polyfills-IE11' );
		}

		if ( 'IntersectionObserver' in window ) {
			// Intersection observer is supported so do nothing
		} else {
			// Load the intersection observer polyfill
			requiredPolyfills.push( 'vendor/core/intersection-observer' );
		}

		if ( FRAMEWORK.requireInitConfig.localeUrl !== null ) {
			// If a custom locale file has been supplied then load it as a dependancy
			requiredScripts.push( FRAMEWORK.requireInitConfig.localeUrl );
		}
		if ( FRAMEWORK.requireInitConfig.settingsUrl !== null ) {
			// If a custom component settings file has been supplied then load it as a dependancy
			requiredScripts.push( FRAMEWORK.requireInitConfig.settingsUrl );
		}

		if ( requiredPolyfills.length === 0 ) {
			// No polyfills are required so just move onto loading the other files
			FRAMEWORK.functions.setupPagePart2( requiredScripts );
		} else {
			// Polyfills are required so load these first
			FRAMEWORK.require( requiredPolyfills, function run() {
				FRAMEWORK.functions.setupPagePart2( requiredScripts );
			});
		}
	},

	setupPagePart2 : function( requiredScripts ) {
		'use strict';

		FRAMEWORK.require( requiredScripts, function run( utility, cookie ) {
			var moduleMutationObserver = new MutationObserver( function listener() {
				FRAMEWORK.functions.moduleScan();
			});

			FRAMEWORK.functions.setLocalisation( utility );
			FRAMEWORK.functions.setComponentSettings( utility );
			FRAMEWORK.functions.setAnimation( utility, cookie );

			utility.trigger( document, 'frameworkready' );

			FRAMEWORK.functions.moduleScan(); // Run initial moduleScan and then observe

			moduleMutationObserver.observe( document.querySelector( 'body' ), {
				childList : true,
				subtree : true,
			});

			document.addEventListener( 'click', function listener( e ) {
				var element = e.target,
					thisHref,
					targetElm,
					tempElm;

				// Get the href of the clicked element if there is one
				if ( element.hasAttribute( 'href' ) ) {
					thisHref = element.getAttribute( 'href' ).match( utility.urlAnchorRegExp );
				} else {
					element = element.closest( 'a[href], button[href]' );
					if ( element ) {
						thisHref = element.getAttribute( 'href' ).match( utility.urlAnchorRegExp );
					}
				}

				// Only try and process if the link is not blank
				if ( Array.isArray( thisHref ) && thisHref[ 0 ] !== '' ) {
					thisHref = thisHref[ 0 ];
					if ( thisHref.indexOf( '#' ) === 0 ) {
						thisHref = '#' + CSS.escape( thisHref.substr( 1 ) );
					}

					targetElm = document.querySelector( thisHref );

					// If target element exists makes sure parentJS modules are all loaded
					if ( targetElm ) {
						// Loop through all parents loading their modules
						tempElm = targetElm.closest( '.has-module-observer' );

						while ( tempElm ) {
							FRAMEWORK.functions.loadModules( tempElm );
							tempElm = tempElm.parentNode.closest( '.has-module-observer' );
						}
					}
				}
			});
		});
	},
};

( function fn() {
	'use strict';

	/*
	 * Check browser has minimum level of feature support
	 * Bar set at IE11 using techniques covered https://walterebert.com/blog/gracefully-ignoring-old-browsers/
	 */

	if ( 'Intl' in window ) {
		FRAMEWORK.functions.setupInitital();

		// If a custom require extend file has been supplied then load it as a dependancy otherwise just run as normal
		if ( FRAMEWORK.requireInitConfig.customRequireConfigUrl === null ) {
			// If no custom require config has been specified just setup require for Framework straight away
			FRAMEWORK.functions.extendRequire();
			FRAMEWORK.require = require.config( FRAMEWORK.requireConfig ); // Setup Framework specific instance of require
			FRAMEWORK.functions.setupPage();
		} else {
			// If a custom require extend file has been supplied then load it as a dependancy
			FRAMEWORK.require = require.config( FRAMEWORK.requireBasicConfig );
			FRAMEWORK.require( [ FRAMEWORK.requireInitConfig.customRequireConfigUrl ], function run() {
				FRAMEWORK.functions.extendRequire();
				FRAMEWORK.require = require.config( FRAMEWORK.requireConfig ); // Setup Framework specific instance of require
				FRAMEWORK.functions.setupPage();
			});
		}
	}
})();
